import { useMemo, useState } from 'react'

import { useNavigation, useRoute } from '@react-navigation/native'
import {
  useBrandDetailsById,
  useCustomerByPartnerId,
} from '@zet/feature-brands/api/brands/hooks'
import { Customer } from '@zet/feature-brands/api/brands/types'
import _ from 'lodash'

interface IListData {
  highApprovalCustomers: Customer[]
  allCustomers: Customer[]
  hasNextPage: boolean
}
const useBrandEligibleCustomers = () => {
  const { params } = useRoute()
  const brandId = params?.brandId
  const isHold = !!params?.isHold
  const [searchText, setSearchText] = useState('')

  const {
    data,
    isLoading,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    refetch,
  } = useCustomerByPartnerId(brandId, searchText)

  const dataList = useMemo(() => {
    let temp: IListData = {
      highApprovalCustomers: [],
      allCustomers: [],
      hasNextPage: false,
    }
    data?.pages?.forEach((page) => {
      temp = {
        ...temp,
        highApprovalCustomers: [
          ...temp.highApprovalCustomers,
          ...(page?.highApprovalCustomers || []),
        ],
        allCustomers: [...temp.allCustomers, ...(page?.allCustomers || [])],
        hasNextPage: temp?.hasNextPage || false,
      }
    })
    return temp
  }, [data?.pages])

  const { data: content } = useBrandDetailsById(brandId)
  const brandName = content?.name
  const brandCategory = content?.subCategory
  const { navigate } = useNavigation()

  const handleChange = (text: string) => {
    setSearchText(text)
    _.debounce(refetch, 1000)
  }

  const clearSearch = () => {
    setSearchText('')
  }

  return {
    brandName,
    brandCategory,
    dataList,
    searchText,
    handleChange,
    navigate,
    isHold,
    brandId,
    isLoading,
    clearSearch,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  }
}

export default useBrandEligibleCustomers
